const STORAGE_KEY = 'cardapio-sischef:totem-sessao'

let emMemoria: string | null = null

export function guardarSessaoTotem(token: string): void {
  emMemoria = token
  try {
    sessionStorage.setItem(STORAGE_KEY, token)
  } catch {
    /* sessionStorage indisponível — segue em memória */
  }
}

export function obterSessaoTotem(): string | null {
  try {
    return sessionStorage.getItem(STORAGE_KEY) ?? emMemoria
  } catch {
    return emMemoria
  }
}

export function limparSessaoTotem(): void {
  emMemoria = null
  try {
    sessionStorage.removeItem(STORAGE_KEY)
  } catch {
    /* sessionStorage indisponível — segue em memória */
  }
}
